
import {parseISO, getHours} from 'date-fns';

import ConfigService from "./ConfigService";
import HttpService from "./HttpService";




export default class WeatherService 
{
  constructor(coreDomain) 
  {
    this.configService = new ConfigService();
    this.domain = coreDomain || this.configService.getWeatherServiceHost();
  }

  async fetchVersion(token) 
  {
    const path = "/api/admin/version";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }





async fetchWeatherData(lat, lng, gcid, token) 
{
    const path = "/api/weather/gcid/" + gcid + "/weather/current/lat/" + lat + "/lng/" + lng;
    var response = await HttpService.get(this.domain, path, token);
    return response;
}


async fetchHistoricalWeatherData(lat, lng, isoInspectionDateTime, gcid, token) 
{
  const path = "/api/weather/gcid/" + gcid + "/weather/historical/lat/" + lat + "/lng/" + lng + "/date/" + isoInspectionDateTime;
  var response = await HttpService.get(this.domain, path, token);
  if (response.hasError) return response;
  // we want to get the weather for the closest HOUR to our inspection date/time
  var dateOnly = isoInspectionDateTime.split('T')[0];
  var hour = getHours(parseISO(isoInspectionDateTime));
  var hourString = (hour === 0) ? "0" : hour + "00";
  var hourNode = response.dataResult.historical[dateOnly].hourly.find((h) => h.time == hourString);
  if (hourNode){
    response.dataResult = hourNode;
  }
  else {
    response.hasError = true;
    response.messages.push("Unable to find historical weather data for " + isoInspectionDateTime);
  }

  return response;
}

}